// extracted by mini-css-extract-plugin
export default {"label":"PopupOpenerButton_label__M0X4s","labelSelected":"PopupOpenerButton_labelSelected__d7T6h","labelEllipsis":"PopupOpenerButton_labelEllipsis__9-zxd"};